import type EnhancedLocation from 'owa-service/lib/contract/EnhancedLocation';
import isEnhancedLocation from 'owa-location-persona/lib/utils/isEnhancedLocation';
import { LocationMetricType } from 'owa-calendar-helpers-types';

/**
 * This function returns location metric type based on the location type ( None, String, Enhanced)
 * @param location - enhanced location
 */
export default function getMetricLocationType(
    location: EnhancedLocation | null
): LocationMetricType {
    if (!location) {
        return LocationMetricType.None;
    }

    let isQCenhancedLocation: boolean = location.PostalAddress
        ? isEnhancedLocation(location.PostalAddress)
        : false;
    if (isQCenhancedLocation) {
        return LocationMetricType.Enhanced;
    }
    return LocationMetricType.String;
}
